/** Shared keyboard focus ring for icon-only / unstyled controls (WCAG 2.4.7). */
export const A11Y_FOCUS_VISIBLE = {
  _focus: {
    boxShadow: 'none',
    outline: 'none',
  },
  _focusVisible: {
    boxShadow: '0 0 0 3px #1B96FF',
    outline: '2px solid transparent',
  },
};
